export const PATH_CAMPAIGNS = 'campaigns';
export const PATH_ASSET = 'asset';
export const PATH_EDITION_EDIT = 'editionedit';
export const PATH_AUDIENCE = 'audiences';
export const PATH_ANALYTICS = 'analytics';

export const TAB_CAMPAIGNS = {
  CONTENT: 'content', // campaign all assets listing page
  SOURCED_CONTENT: 'source',
  ASSET: 'asset',
  AUDIENCE: 'audience',
  DASHBOARD: 'dashboard',
  PREVIOUS_CONTENT: 'previous',
  PREVIOUSLY_SENT: 'sent',
  PUBLISH: 'publish',
  DESIGN: 'design',
  FAVORITES: 'favorites',
};

export const TAB_ASSET = {
  SOURCED_CONTENT: 'source',
  AUDIENCE: 'audience',
  // DASHBOARD: "dashboard",
  PREVIOUSLY_SENT: 'sent',
};

export const TAB_EDITION = {
  CURATED: 'editionedit',
  SOURCE: 'source',
  FAVORITES: 'favorites',
  DESIGN: 'design',
  PUBLISH: 'publish',
};

export const TAB_AUDIENCE = {
  ACCOUNTS: 'accounts',
  LISTS: 'lists',
  PEOPLE: 'people',
  CONTACTS: 'contacts',
  SEARCH: 'search',
  VIEW: 'view',
  ALL: 'all',
  ADD: 'add',
};

export const TAB_ANALYTICS = {
  ACCOUNTS: 'accounts',
  CAMPAIGNS_ASSET: 'campaigns-assets',
  LISTS: 'lists',
  CONTACTS: 'contacts',
  CONTENT: 'content',
  INSIGHTS: 'insights',
  TRENDS: 'trends',
  CONTENT_CONTACTS: 'content/contacts',
  EMAIL_ENGAGEMENT: 'email_engagement',
  AUDIT_TRAIL: 'audit_trail',
};

export const TAB_CONTACTS_ANALYTICS = {
  DELIVERED: 'delivered',
  BOUNCED: 'bounced',
  UNSUBSCRIBED: 'unsubscribed',
  ALL: 'all_contacts',
};

export const TAB_ANALYTICS_INNER = {
  DASHBOARD: 'dashboard',
  CONTENT: 'content',
  EMAIL_ENGAGEMENT: 'email_engagement',
  AUDIT_TRAIL: 'audit_trail',
};
